export default __webpack_public_path__ + "static/media/gps-addon.c1f0f2c9.svg";